import { css, cx } from '@repo/pandacss/css';
import { type MaskIconVariantProps, maskIcon } from '@repo/pandacss/recipes';
import type { SystemStyleObject } from '@repo/pandacss/types';
import type { ComponentPropsWithRef } from 'react';

type MaskIconProps = MaskIconVariantProps &
  ComponentPropsWithRef<'span'> & {
    glyph: MaskIconVariantProps['glyph'];
    css?: SystemStyleObject;
    className?: string;
  };

export const MaskIcon = ({ glyph, size, className, css: cssProp, ...props }: MaskIconProps) => {
  return (
    <span
      data-icon={glyph}
      aria-hidden="true"
      className={cx(maskIcon({ glyph, size }), css(cssProp), className)}
      {...props}
    />
  );
};
